import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSharedListFilter } from './useSharedListFilter';

export const SharedListFilter = ({ value, setFilters }) => {
  const { formSchema, defaultOptions, isLoading, onSearchChange, onSubmit, onMenuOpen } = useSharedListFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ sharedListIds: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="sharedListIds"
          label="Lists"
          placeholder="Add..."
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          defaultOptions={defaultOptions}
          onMenuOpen={onMenuOpen}
          isLoading={isLoading}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SharedListFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

SharedListFilter.defaultProps = {
  value: [],
};
